<!--begin::403 Forbidden Page-->
<div class="d-flex flex-column flex-center" style="min-height: 100vh; background-color: #f5f8fa;">
  <!--begin::Wrapper-->
  <div class="w-lg-600px p-10 text-center">
    <!--begin::Icon-->
    <div class="mb-10">
      <i class="ki-duotone ki-shield-cross fs-10x text-danger">
        <span class="path1"></span>
        <span class="path2"></span>
        <span class="path3"></span>
      </i>
    </div>
    <!--end::Icon-->

    <!--begin::Title-->
    <h1 class="fw-bolder mb-5" style="font-size: 4rem; color: #181c32;">403</h1>
    <!--end::Title-->

    <!--begin::Subtitle-->
    <h2 class="fw-bold text-gray-900 mb-3">Access Forbidden</h2>
    <!--end::Subtitle-->

    <!--begin::Message-->
    <div class="fw-semibold fs-5 text-gray-600 mb-10">
      You don't have permission to access this page.<br />
      Please contact your administrator if you believe this is an error.
    </div>
    <!--end::Message-->

    <!--begin::Actions-->
    <div class="d-flex justify-content-center gap-3">
      <!--begin::Back Button-->
      <button type="button" class="btn btn-lg btn-light-primary" (click)="goBack()">
        <i class="ki-duotone ki-arrow-left fs-2 me-2">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        Go Back
      </button>
      <!--end::Back Button-->

      <!--begin::Dashboard Button-->
      <button type="button" class="btn btn-lg btn-primary" (click)="goToDashboard()">
        <i class="ki-duotone ki-home fs-2 me-2">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        Go to Dashboard
      </button>
      <!--end::Dashboard Button-->
    </div>
    <!--end::Actions-->

    <!--begin::Illustration-->
    <div class="mt-15">
      <img src="assets/media/illustrations/sketchy-1/18.png" alt="403 Forbidden" class="mw-100 mh-300px" />
    </div>
    <!--end::Illustration-->
  </div>
  <!--end::Wrapper-->
</div>
<!--end::403 Forbidden Page-->

